import DataTable from '../../../../../components/DataTable'
import { nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../../components/Container'

const menuFoodTypesList = (): JSX.Element => (
  <Container pageTitle="Listagem" breadcrumb={breadcrumbList} tools={toolsList}>
    <DataTable
      source={nameSource}
      entity={nameEntity}
      format={{ orderBy: 'name' }}
      notHasChildren
      headers={headers}
      actions={[
        {
          name: 'Visualizar',
          title: 'Visualizar',
          spanIcon: 'fa fa-search',
          linkTo: menuFoodType =>
            `/commercial/menuFoodTypes/view/${menuFoodType.id}`,
          style: { margin: '0 5px' }
        },
        {
          name: 'Editar',
          title: 'Editar',
          spanIcon: 'fa fa-edit',
          linkTo: menuFoodType =>
            `/commercial/menuFoodTypes/update/${menuFoodType.id}`
        }
      ]}
    />
  </Container>
)

export default menuFoodTypesList
